export const SEARCH_SPLIT_REGEX = /[\s+/-]/g;

export const DROPDOWN_SEARCH_DEFAULT_MAX_LENGTH = 200;
/**
 * Delay before restoring focus after collapse.
 * 300ms matches `accordion-slide-*` in container/tailwind.config.js, plus 50ms
 * buffer because the timeout is scheduled after React state updates, not when
 * the CSS animation starts. Not used on expand — immediate focus is enough there.
 */
export const ACCORDION_TOGGLE_ANIMATION_MS = 350;
